import { IPmListFilterRaw } from 'PreventionPackage/MainModule/interfaces/IPmListFilterRaw';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { mapPmFilterToRaw } from 'PreventionPackage/PmListFiltersModule/common/mapPmFilterToRaw';
import { initialPmListFilter } from 'PreventionPackage/PmListFiltersModule/constants/initialPmListFilter';
import { IPmListFilter } from 'PreventionPackage/PmListFiltersModule/interfaces/IPmListFilter';

export function getRawFilter(): IPmListFilterRaw {
  const current = getStorageItem<IPmListFilter>(StorageNamesEnum.PM_FILTER);
  const isFilterOn = !!getStorageItem(StorageNamesEnum.PM_FILTER_ON);
  const rawFilterData = mapPmFilterToRaw((isFilterOn && current) || initialPmListFilter);

  return {
    ...rawFilterData,
  };
}
